import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MyButton from '../../../components/MyButton';
import MyCheckBox from '../../../components/MyCheckbox';
import Api from '../../../Api';
import { formatLanguageDisplayName } from '../../../helpers/interfaceLanguages';

function SelectLanguages({
  setValue, setTempComponentState, initValue = [],
}) {
  const { languages } = useSelector((store) => store.staticData);
  const [selected, setSelected] = useState(initValue);

  const handleClick = (item) => {
    if (selected.some((el) => el._id === item._id)) {
      setSelected((prev) => prev.filter((el) => el._id !== item._id));
    } else {
      setSelected((prev) => [...prev, item]);
    }
  };

  const handleSubmit = () => {
    setValue(selected);
    setTempComponentState(null);
  };

  const sortedLanguages = [...(languages || [])].sort((a, b) => {
    const aInterface = a.is_interface_language ? 0 : 1;
    const bInterface = b.is_interface_language ? 0 : 1;
    if (aInterface !== bInterface) return aInterface - bInterface;
    return (a.name || '').localeCompare(b.name || '', 'ru');
  });

  return (
    <div className="temp_container">
      <p className="temp_container_title">Выберите языки</p>
      <p className="temp_container_hint" style={{ marginBottom: 12, fontSize: 13, opacity: 0.7 }}>
        Среди выбранных должен быть хотя бы один язык интерфейса (если карточка не «для всех языков»).
      </p>
      <div className="temp_container_scroll with_button">
        {sortedLanguages.map((item) => {
          const label = [
            formatLanguageDisplayName(item),
            item.is_interface_language ? '· интерфейс' : '',
          ].filter(Boolean).join(' ');
          return (
            <MyCheckBox
              key={item._id}
              imgUrl={item.flag_url ? Api.url + item.flag_url : undefined}
              value={selected.some((el) => el._id === item._id)}
              onClick={() => handleClick(item)}
              text={label}
              wrapperClassName="temp_container_item"
            />
          );
        })}
      </div>

      <MyButton onClick={handleSubmit} text="Ок" className="temp_container_button" />
    </div>
  );
}

export default SelectLanguages;
